import React, { useState, useEffect, useCallback } from "react";
import PricingPage from '../components/PricingPage';
import SubscriptionService from "../services/Subscription";
import { showSuccessToast, showErrorToast } from "../utils/AlertUtils";
import { useLoading } from "../context/LoadingContext";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Pricing = () => {
    const { setIsLoading, setLoadingMessage } = useLoading();
    const navigate = useNavigate();
    const [plans, setPlans] = useState([]);
    const { login } = useAuth();

    const fetchData = useCallback(async () => {
        try {
          setIsLoading(true);
          const response = await SubscriptionService.getSubscriptionPlans();
          if(response && response.statusCode === 200) {
            const subscriptionPlans = response?.data;
            setPlans(subscriptionPlans);
          }
        } catch (error) {
          console.error("Error fetching subscription plans", error);
          showErrorToast(error.message);
        } finally {
          setIsLoading(false);
        }
    }, [setIsLoading]);
    
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };
    const handleCheckout = async (subscriptionPlanData) => {
        const isScriptLoaded = await loadRazorpayScript();
        if (!isScriptLoaded) {
            showErrorToast('Razorpay SDK લોડ થવામાં નિષ્ફળ ગયું. કૃપા કરીને તમારું ઇન્ટરનેટ કનેક્શન તપાસો અથવા પછીથી ફરી પ્રયાસ કરો.');
            return;
        }

        if (!window.Razorpay) {
            showErrorToast('Razorpay ઉપલબ્ધ નથી. ખાતરી કરો કે સ્ક્રિપ્ટ યોગ્ય રીતે લોડ થઈ છે.');
            return;
        }
        try {
            // 1. Create Order on Backend
            const orderResponse = await SubscriptionService.createOrder({
                "subscriptionId": subscriptionPlanData._id
            });
            if (orderResponse && orderResponse.statusCode !== 200) {
                showErrorToast(orderResponse?.message);
            }
            const orderData = orderResponse.data;

            // 2. Load Razorpay Checkout Script and Open Checkout
            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY_ID,
                amount: orderData.amount,
                currency: orderData.currency,
                order_id: orderData.orderId,
                name: 'EASYROJMEL',
                description: subscriptionPlanData?.description,
                image: '../dist/img/logos/dark-logo-3.png',
                handler: async function (response) {
                    if(response && response.razorpay_payment_id) {
                        setIsLoading(true);
                        setLoadingMessage("ચુકવણી સફળ! કૃપા કરીને રાહ જુઓ...");
                        const userDetails = localStorage.getItem('userDetails');
                        const token = localStorage.getItem("token");
                        const jsonParseUserDetails = JSON.parse(userDetails);
                        if(jsonParseUserDetails) {
                            jsonParseUserDetails.current_subscription_id = subscriptionPlanData._id;
                            login(token, jsonParseUserDetails);
                        }
                        setTimeout(() => {
                            setLoadingMessage(null);
                            setIsLoading(false);
                            navigate('/dashboard');
                            showSuccessToast('તમારી ચુકવણી સફળતાપૂર્વક પૂર્ણ થઈ છે!!');
                        }, 10000);
                    }
                },
                theme: {
                    color: '#3399cc'
                }
            };
            const rzp1 = new window.Razorpay(options);
            rzp1.open();

            rzp1.on('payment.failed', function (response){
                const errorMsg = 'ચુકવણી નિષ્ફળ: ' + response.error.code + ' | ' + response.error.description;
                showErrorToast(errorMsg);
            });
        } catch (error) {
            console.error("Error during checkout:", error);
            showErrorToast("Razorpay ચેકઆઉટ નિષ્ફળ ગયું! કૃપા કરીને ફરી પ્રયાસ કરો.");
        } finally {
            setIsLoading(false);
            setLoadingMessage(null);
        }
    };

  return (
    <div>
      <PricingPage handleCheckout={handleCheckout} plans={plans} />
    </div>
  );
};

export default Pricing;